import axiosInstance from "../../../api/axiosInstance";

export const fetchCategories = async (params = {}) => {
 try {
 const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
 const res = await axiosInstance.get("/public/official-sentences/categories", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchCategoryById = async (id) => {
 try {
 const res = await axiosInstance.get(`/public/official-sentences/categories/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchOfficialSentences = async (params) => {
 try {
 const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
 const res = await axiosInstance.get("/public/official-sentences", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchOfficialSentenceById = async (id) => {
 try {
 const res = await axiosInstance.get(`/public/official-sentences/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchSentenceOptions = async () => {
 try {
 const res = await axiosInstance.get("/public/official-sentences/options");
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch options" };
 }
};
